module.exports = __webpack_public_path__ + "static/media/daytime.82aad593.png";